import React from 'react'
import moment from 'moment'
import OperacionesListadoRepresentantes from '../components/OperacionesListadoRepresentantes'
import TableValueAction from '../../MuiTable/components/TableValueAction'
import InfoCpa from '../../Camiones/containers/busquedaCpa/InfoCpa'

export const COLUMNS_CALADO_REPRESENTANTES = [
  {
    name: 'numero',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'egresoCalado',
    label: ' ',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox',
      customBodyRender: e => { return (<></>) }
    }
  },
  {
    name: 'fechaDeCalado',
    label: 'Fecha de calado',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (f) => {
        return moment(f).format('DD-MM-YYYY HH:mm')
      }
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'razonSocialTitularDeCupoNominado',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'razonSocialVendedor',
    label: 'Entregador',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'estado',
    label: 'Estado proceso',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'humedad',
    label: 'Humedad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'calificacion',
    label: 'Calificación cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'calificacionDos',
    label: 'Calificación cereal 2',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'estadoAutorizacion',
    label: 'Estado autorización',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'detalle',
    label: 'Operaciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: detalle => {
        return (
          <OperacionesListadoRepresentantes detalle={detalle} />
        )
      }
    }
  }
]

export const COLUMNS_CALADO_REPRESENTANTES_TO_PRINT = [
  {
    name: 'numero',
    label: 'Carta Porte',
    width: '65'
  },
  {
    name: 'fechaCalado',
    label: 'Calado',
    width: '50'
  },
  {
    name: 'nombreCereal',
    label: 'Cereal',
    width: '70'
  },
  {
    name: 'razonSocialExportador',
    label: 'Exportador',
    width: '120'
  },
  {
    name: 'razonSocialTitularDeCupoNominado',
    label: 'Cargador',
    width: '120'
  },
  {
    name: 'razonSocialVendedor',
    label: 'Entregador',
    width: '120'
  },
  {
    name: 'estado',
    label: 'Estado',
    width: '50'
  },
  {
    name: 'calificacion',
    label: 'Calificación',
    width: '120'
  },
  {
    name: 'calificacionDos',
    label: 'Calificación 2',
    width: '120'
  }
]
